import "./MethodArgumentsInput.moduleRenamed.css";

export const list = "MethodArgumentsInput-module__list___uRz0c";
export const itemTitle = "MethodArgumentsInput-module__itemTitle___TALgg";
export const itemTitleIndex = "MethodArgumentsInput-module__itemTitleIndex___uaH8-";
export const itemTitleActions = "MethodArgumentsInput-module__itemTitleActions___hTXct";
export const itemAction = "MethodArgumentsInput-module__itemAction___jXzEv";
export const manualBoxAnchor = "MethodArgumentsInput-module__manualBoxAnchor___iyuLd";
export const manualBox = "MethodArgumentsInput-module__manualBox___sS-WT";
export const mkTooltip = "MethodArgumentsInput-module__mkTooltip___S64jw";
export const defaultBtn = "MethodArgumentsInput-module__defaultBtn___0SV3Y";

export default {
  list: "MethodArgumentsInput-module__list___uRz0c",
  itemTitle: "MethodArgumentsInput-module__itemTitle___TALgg",
  itemTitleIndex: "MethodArgumentsInput-module__itemTitleIndex___uaH8-",
  itemTitleActions: "MethodArgumentsInput-module__itemTitleActions___hTXct",
  itemAction: "MethodArgumentsInput-module__itemAction___jXzEv",
  manualBoxAnchor: "MethodArgumentsInput-module__manualBoxAnchor___iyuLd",
  manualBox: "MethodArgumentsInput-module__manualBox___sS-WT",
  mkTooltip: "MethodArgumentsInput-module__mkTooltip___S64jw",
  defaultBtn: "MethodArgumentsInput-module__defaultBtn___0SV3Y",
};